<script setup lang="ts">
import './assets/style.scss'
import type { InventoryMapInfoType } from '@/entities/Inventory/Main'
import { useAuth } from '@/entities/Auth'

const { isPermissions } = useAuth()

const item = defineModel<InventoryMapInfoType>()
</script>

<template>
  <div v-if="item" class="mb-4">
    <VCheckbox
      class="mb-2"
      v-model="item.is_projecting"
      density="compact"
      :label="$t('itf.is_project')"
      :disabled="!isPermissions(['OBJECT_EDIT'])"
    />

    <VTextField
      class="mb-2"
      v-model="item.name"
      hide-details
      :label="$t('itf.name_label')"
      :disabled="!isPermissions(['OBJECT_EDIT'])"
    />

    <VTextarea
      v-if="item.invent_object_type.properties.is_comment"
      class="mb-2"
      v-model="item.comment"
      hide-details
      :label="$t('itf.comment')"
      :disabled="!isPermissions(['OBJECT_EDIT'])"
    />
  </div>
</template>
